import request from '@/utils/request'

let Ma_training_industryApi = {

  /*培训行业列表*/
  list(data) {
    return request._post('/shop/plus.ma_training_industry.Index/index', data);
},
/*添加培训行业*/
add(data) {
    return request._post('/shop/plus.ma_training_industry.Index/add', data);
},
/*修改培训行业*/
edit(data) {
    return request._post('/shop/plus.ma_training_industry.Index/edit', data);
},
/*删除培训行业*/
del(data) {
    return request._post('/shop/plus.ma_training_industry.Index/del', data);
},
/*培训行业详情*/
detail(data) {
  return request._post('/shop/plus.ma_training_industry.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_training_industry.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_training_industry.Setting/getSetting', data, errorback);
    },
}
export default Ma_training_industryApi;



// WEBPACK FOOTER //
// ./src/api/ma_training_industry.js